// Partial — showcase da Central de Conquistas (revisão da equipe, 11/07).
// Rota sem link de navegação; página estática sem rede e sem mutação.
import { createElement } from "react";
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { Navigate, useLocation } from "react-router-dom";
import { RequireAuth } from "@/features/auth";
import { areaFromDestination } from "./v3/conquests-area";
import { withConquestsAreaSearchParams } from "./v3/conquests-url";

const GamificationShowcasePage = lazyWithRetry(
  () => import("./showcase/GamificationShowcasePage"),
);

function LegacyConquestsRedirect() {
  const location = useLocation();
  return createElement(Navigate, {
    to: conquestsRedirectTarget(
      location.pathname,
      location.search,
      location.hash,
    ),
    replace: true,
  });
}

export function conquestsRedirectTarget(
  pathname: string,
  search: string,
  hash = "",
): string {
  const query = new URLSearchParams(search);
  const target = withConquestsAreaSearchParams(
    query,
    areaFromDestination(`${pathname}${search}`),
  );
  // #242 C1b: preserva a âncora (ex.: #conquests-profile-history) na entrada
  // direta por URL legada — o perfil da Central foca a seção ao montar.
  return `/?${target.toString()}${hash}`;
}

const routes: RouteObject[] = [
  { path: "/gamification-showcase", Component: GamificationShowcasePage },
  {
    Component: RequireAuth,
    children: [
      { path: "/gamification", Component: LegacyConquestsRedirect },
      { path: "/ranking", Component: LegacyConquestsRedirect },
      { path: "/gamification/history", Component: LegacyConquestsRedirect },
    ],
  },
];

export default routes;
